import { render, staticRenderFns } from "./NewCotizador.vue?vue&type=template&id=1bbd42f6"
import script from "./NewCotizador.vue?vue&type=script&lang=js"
export * from "./NewCotizador.vue?vue&type=script&lang=js"
import style0 from "./NewCotizador.vue?vue&type=style&index=0&id=1bbd42f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports